<div class="ddc-admin-ai-root">
  <!-- Header -->
  <div class="ddc-admin-ai-header">
    <div class="ddc-admin-ai-header-content">
      <button class="ddc-admin-ai-back-btn" (click)="goBack()">
        <i class="material-icons">arrow_back</i>
        Back to Admin
      </button>
      <h1 class="ddc-admin-ai-title">
        <i class="material-icons">auto_awesome</i>
        AI Dictionary CSV Generation
      </h1>
      <button class="ddc-admin-ai-refresh-btn" [disabled]="isLoading" (click)="resetForm()">
        <i class="material-icons">refresh</i>
        Reset
      </button>
    </div>
  </div>

  <!-- Tab Navigation -->
  <div class="ddc-admin-ai-tabs">
    <button class="ddc-admin-ai-tab-btn" [class.active]="activeTab === 'generate'" (click)="setActiveTab('generate')">
      Generate CSV
    </button>
    <button class="ddc-admin-ai-tab-btn" [class.active]="activeTab === 'assign'" (click)="setActiveTab('assign')">
      Assign
    </button>
    <button class="ddc-admin-ai-tab-btn" [class.active]="activeTab === 'manage'" (click)="setActiveTab('manage')">
      Manage
    </button>
  </div>

  <!-- Main Content -->
  <div class="ddc-admin-ai-main">
    <!-- Generate CSV Tab -->
    <ng-container *ngIf="activeTab === 'generate'">
      <!-- Loading State -->
      <div class="loading-container" *ngIf="isLoading && users.length === 0">
        <i class="material-icons spinning">hourglass_empty</i>
        <p>Loading users...</p>
      </div>

      <!-- Form Container -->
      <div class="ddc-admin-ai-card" *ngIf="!isLoading || users.length > 0">
        <div class="ddc-admin-ai-card-header">
          <h2>Generate AI Dictionary</h2>
          <p>Fill out the form below to generate a new dictionary using AI based on your specifications.</p>
        </div>

        <!-- Error Message -->
        <div class="ddc-admin-ai-alert ddc-admin-ai-alert-error" *ngIf="error">
          <i class="material-icons">error</i>
          <span>{{ error }}</span>
        </div>

        <!-- Success Message -->
        <div class="ddc-admin-ai-alert ddc-admin-ai-alert-success" *ngIf="success">
          <i class="material-icons">check_circle</i>
          <span>{{ success }}</span>
        </div>

        <!-- Existing Form -->
        <form class="ddc-admin-ai-form" (ngSubmit)="submitRequest()">
          <!-- ...existing code for the form... -->
          <!-- User Selection (commented out) -->
          <!-- Dictionary Type -->
          <div>
            <label
              ><i class="material-icons text-base">translate</i>
              <span class="ddc-admin-ai-label">Dictionary Type</span></label
            >
            <div class="ddc-admin-ai-radio-group">
              <label
                class="ddc-admin-ai-radio-option"
                [class.selector-selected]="formData.dictionaryType === 'monolingual'"
              >
                <input
                  name="dictionaryType"
                  type="radio"
                  value="monolingual"
                  [(ngModel)]="formData.dictionaryType"
                  (change)="onDictionaryTypeChange()"
                />
                <span class="custom-radio"></span>
                <span><i class="material-icons text-base">language</i>Monolingual (Single Language)</span>
              </label>
              <label
                class="ddc-admin-ai-radio-option"
                [class.selector-selected]="formData.dictionaryType === 'bilingual'"
              >
                <input
                  name="dictionaryType"
                  type="radio"
                  value="bilingual"
                  [(ngModel)]="formData.dictionaryType"
                  (change)="onDictionaryTypeChange()"
                />
                <span class="custom-radio"></span>
                <span><i class="material-icons text-base">g_translate</i>Bilingual (Translation)</span>
              </label>
            </div>
          </div>

          <!-- Language Selection -->
          <div>
            <label for="primary-language"
              ><i class="material-icons text-base">language</i>
              <span class="ddc-admin-ai-label">Primary Language</span></label
            >
            <select id="primary-language" name="primaryLanguage" required [(ngModel)]="formData.primaryLanguage">
              <option value="">Select Primary Language</option>
              <option *ngFor="let languageKey of languageKeys" [value]="getLanguageCode(languageKey)">
                {{ languages[languageKey][0] }}
              </option>
            </select>
          </div>

          <!-- Secondary Language (for bilingual) -->
          <div *ngIf="formData.dictionaryType === 'bilingual'">
            <label for="secondary-language"
              ><i class="material-icons text-base">g_translate</i>
              <span class="ddc-admin-ai-label">Secondary Language</span></label
            >
            <select
              id="secondary-language"
              name="secondaryLanguage"
              [required]="formData.dictionaryType === 'bilingual'"
              [(ngModel)]="formData.secondaryLanguage"
            >
              <option value="">Select Secondary Language</option>
              <option
                *ngFor="let languageKey of languageKeys"
                [disabled]="getLanguageCode(languageKey) === formData.primaryLanguage"
                [value]="getLanguageCode(languageKey)"
              >
                {{ languages[languageKey][0] }}
              </option>
            </select>
          </div>

          <!-- Content Counts -->
          <div class="ddc-admin-ai-form-row">
            <div>
              <label for="word-count"
                ><i class="material-icons text-base">fiber_manual_record</i>
                <span class="ddc-admin-ai-label">Number of Words</span></label
              >
              <input
                id="word-count"
                max="1000"
                min="1"
                name="wordCount"
                required
                type="number"
                [(ngModel)]="formData.wordCount"
              />
            </div>
            <div>
              <label for="pair-count"
                ><i class="material-icons text-base">fiber_smart_record</i>
                <span class="ddc-admin-ai-label">Number of Pairs</span></label
              >
              <input
                id="pair-count"
                max="1000"
                min="1"
                name="pairCount"
                required
                type="number"
                [(ngModel)]="formData.pairCount"
              />
            </div>
          </div>

          <!-- Subject -->
          <div>
            <label for="subject"
              ><i class="material-icons text-base">subject</i>
              <span class="ddc-admin-ai-label">Subject/Topic</span></label
            >
            <input
              id="subject"
              name="subject"
              placeholder="e.g., Foods German-English B1 Level"
              required
              type="text"
              [(ngModel)]="formData.subject"
            />
          </div>

          <!-- Description -->
          <div>
            <label for="description"
              ><i class="material-icons text-base">description</i>
              <span class="ddc-admin-ai-label">Description</span></label
            >
            <textarea
              id="description"
              name="description"
              placeholder="Provide detailed description about what should be included in the dictionary..."
              required
              rows="4"
              [(ngModel)]="formData.description"
            ></textarea>
          </div>

          <!-- Privacy Setting -->
          <div>
            <label for="privacy"
              ><i class="material-icons text-base">lock</i> <span class="ddc-admin-ai-label">Privacy</span></label
            >
            <select id="privacy" name="privacy" required [(ngModel)]="formData.privacy">
              <option *ngFor="let option of privacyOptions" [value]="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>

          <!-- Submit Button -->
          <div class="ddc-admin-ai-actions">
            <button class="ddc-admin-ai-btn ddc-admin-ai-btn-primary" type="submit" [disabled]="isLoading">
              <i class="material-icons" *ngIf="isLoading" [class.spinning]="isLoading">hourglass_empty</i>
              <i class="material-icons" *ngIf="!isLoading">auto_awesome</i>
              {{ isLoading ? 'Generating...' : 'Generate Dictionary CSV' }}
              <span *ngIf="isLoading && showTimer" style="margin-left: 10px; font-size: 0.95em; color: #f7f7f7">
                ({{ timerDisplay }})
              </span>
            </button>
          </div>
        </form>
      </div>
    </ng-container>

    <!-- Assign Tab -->
    <ng-container *ngIf="activeTab === 'assign'">
      <div class="ddc-admin-ai-card">
        <div class="ddc-admin-ai-card-header assign-header-flex">
          <div>
            <h2>Assign Dictionary from CSV</h2>
            <p>Upload a CSV file to preview its contents and assign the dictionary to a user.</p>
          </div>
          <button class="ddc-admin-ai-refresh-btn" title="Reload CSV List" (click)="loadAvailableCsvFiles()">
            <i class="material-icons">refresh</i>
            Reload CSV List
          </button>
        </div>
        <!-- File Selector for CSVs in /src/assets/ai-generated/ -->

        <div class="assign-csv-user-row">
          <!-- CSV File Selection -->
          <div class="assign-csv-user-col">
            <label class="assign-label" for="csv-file-select">
              <i class="material-icons text-base">file_present</i>
              <span class="ddc-admin-ai-label">Select CSV File</span>
            </label>
            <mat-form-field appearance="outline" style="width: 100%">
              <input
                matInput
                placeholder="Search CSV File"
                type="text"
                [matAutocomplete]="auto"
                [(ngModel)]="selectedCsvFile"
                (ngModelChange)="filterCsvFiles($event)"
              />
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onCsvFileSelectedFromList()">
                <mat-option *ngFor="let file of filteredCsvFiles" [value]="file">
                  {{ file }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <!-- Privacy -->
          <div class="assign-csv-user-col" *ngIf="csvRows && csvRows.length > 0">
            <label class="assign-label" for="assign-dic-privacy">
              <i class="material-icons text-base">lock</i>
              <span class="ddc-admin-ai-label">Privacy</span>
            </label>
            <select id="assign-dic-privacy" class="assign-select" [(ngModel)]="assignDicPrivacy">
              <option value="P01">Public</option>
              <option value="P02">Followers</option>
              <option value="P03">Private</option>
            </select>
          </div>

          <!-- Assign to User -->
          <div class="assign-csv-user-col" *ngIf="csvRows && csvRows.length > 0">
            <label class="assign-label" for="assign-user-select">
              <i class="material-icons text-base">person</i>
              <span class="ddc-admin-ai-label">Assign to User</span>
            </label>
            <mat-form-field appearance="outline" style="width: 100%">
              <input
                matInput
                placeholder="Search User"
                type="text"
                [matAutocomplete]="userAuto"
                [(ngModel)]="userSearchTerm"
                (ngModelChange)="filterUsers($event)"
              />
              <mat-autocomplete #userAuto="matAutocomplete">
                <mat-option
                  *ngFor="let user of filteredUsers"
                  [value]="user.username"
                  (onSelectionChange)="onUserSelected(user)"
                >
                  {{ user.username }} ({{ user.email }})
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <!-- Assign Button -->
          <div class="assign-csv-user-col assign-btn-col" *ngIf="csvRows && csvRows.length > 0">
            <button
              class="ddc-admin-ai-btn ddc-admin-ai-btn-primary assign-btn"
              [disabled]="!selectedAssignUser || !assignDicPrivacy || isAssigning"
              (click)="assignCsvToUser()"
            >
              <i class="material-icons spinning" *ngIf="isAssigning">hourglass_empty</i>
              <span *ngIf="!isAssigning">Assign Dictionary</span>
              <span *ngIf="isAssigning">Assigning...</span>
            </button>
          </div>
          <!-- Assign error/success messages (moved outside button col for structure) -->
        </div>
        <!-- CSV Dictionary Title/Description Preview -->
        <div class="assign-csv-user-col csv-dic-title-desc" *ngIf="csvRows && csvRows.length > 0">
          <div class="csv-dic-title" *ngIf="csvDicTitle"><strong>Dictionary Title:</strong> {{ csvDicTitle }}</div>
          <div class="csv-dic-desc" *ngIf="csvDicDescription">
            <strong>Description:</strong> {{ csvDicDescription }}
          </div>
          <!-- show exact rows count of the file -->
          <div class="csv-dic-rows" *ngIf="csvRows && csvRows.length > 0">
            <strong>Rows:</strong> {{ csvRows.length }}
          </div>
        </div>
        <div class="ddc-admin-ai-alert ddc-admin-ai-alert-error assign-alert" *ngIf="assignError">
          <i class="material-icons">error</i>
          <span>{{ assignError }}</span>
        </div>
        <div class="ddc-admin-ai-alert ddc-admin-ai-alert-success assign-alert" *ngIf="assignSuccess">
          <i class="material-icons">check_circle</i>
          <span>{{ assignSuccess }}</span>
        </div>
        <!-- Table Preview -->
        <div class="csv-table-container" *ngIf="csvRows && csvRows.length > 0">
          <table class="csv-table styled-csv-table">
            <thead>
              <tr>
                <th *ngFor="let header of csvHeaders">{{ header }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of paginatedCsvRows; let i = index" [class.alt-row]="i % 2 === 1">
                <td *ngFor="let header of csvHeaders">{{ row[header] }}</td>
              </tr>
            </tbody>
          </table>
          <!-- Pagination Controls -->
          <div class="csv-pagination" *ngIf="csvTotalPages > 1">
            <button [disabled]="csvPage === 1" (click)="prevCsvPage()">&laquo; Prev</button>
            <span>Page {{ csvPage }} of {{ csvTotalPages }}</span>
            <button [disabled]="csvPage === csvTotalPages" (click)="nextCsvPage()">Next &raquo;</button>
          </div>
        </div>
      </div>
    </ng-container>
    <!-- Manage Tab -->
    <ng-container *ngIf="activeTab === 'manage'">
      <div class="ddc-admin-ai-card">
        <div class="ddc-admin-ai-card-header assign-header-flex">
          <div>
            <h2>Manage Dictionary from CSV</h2>
            <p>Manage AI generated dictionaries</p>
          </div>
        </div>
        <div class="manage-table-container" *ngIf="isLoadingDics && !dictionaries">
          <i class="material-icons spinning">hourglass_empty</i>
          <p>Loading dictionaries...</p>
        </div>
        <div class="manage-table-container" *ngIf="!isLoadingDics && dictionaries">
          <table class="styled-table">
            <thead>
              <tr>
                <th>Title</th>
                <th class="actions-header">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="responsive-row"
                *ngFor="let dict of filteredDictionaries; let i = index"
                [class.alt-row]="i % 2 === 1"
              >
                <td class="manage-title">
                  <span class="dict-title-text">{{ dict.title }}</span>
                </td>
                <td class="manage-actions">
                  <button
                    class="manage-action-btn"
                    aria-label="Delete Dictionary"
                    color="warn"
                    mat-raised-button
                    (click)="deleteDictionary(dict.id)"
                  >
                    <mat-icon>delete</mat-icon>
                    <span class="btn-label">Delete</span>
                  </button>
                  <button
                    class="manage-action-btn"
                    aria-label="Extend Dictionary"
                    color="primary"
                    mat-raised-button
                    (click)="extendDictionary(dict)"
                  >
                    <mat-icon>add_circle_outline</mat-icon>
                    <span class="btn-label">Extend</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>
  </div>
</div>
